<h1>{{ title() }}</h1>

<ul>
  <li style="font-size: larger; font-family: sans-serif">
    <b>Tenant:</b> {{ tenant() }}
  </li>
  <li style="font-size: larger; font-family: sans-serif">
    <b>API URL:</b> {{ apiUrl() }}
  </li>
</ul>
<router-outlet />
